const appBar = {
  styleOverrides: {
    root: {
      boxShadow: "none",
    },
  },
};

export default appBar;
